import React, { FC } from 'react';
import { NavDocumentAnalyzerDropdown } from './NavDocumentAnalyzerDropdown';
import styles from './nav_document_analyzer.module.scss';
import { NavItemDropdown } from '../components/item/NavItem';

type Props = {
  cancelHover: (display: boolean, dropdown: string) => void;
};

export const NavDocumentAnalyzer: FC<Props> = ({ cancelHover }) => (
  <NavItemDropdown className={styles.container}>
    {(isOpen, toggle) => (
      <NavDocumentAnalyzerDropdown
        cancelHover={cancelHover}
        isOpen={isOpen}
        toggle={toggle}
      />
    )}
  </NavItemDropdown>
);
